// ag-grid does use the editing cell prop's "eventKey" to provide the key that started the edit,
// however the keys F2 and Enter do trigger the editing as well, see https://www.ag-grid.com/javascript-data-grid/cell-editing-start-stop/
// this is supposed to be taken into consideration by ag-grid but it does not seem to be ! (version 30.2.0)
export function isPrintableKey(eventKey: string | null) {
  return !(eventKey === "F2" || eventKey === "Backspace" || eventKey === "Enter" || eventKey == null);
}

export function isBackspace(eventKey: string | null) {
  return eventKey === "Backspace";
}
